import Vue from 'vue';
import Router from 'vue-router';

import auth from '@/auth';
import config from '@/config';
import wechat from '@/wechat';
import store from '@/store';

import { FETCH_WECHAT_USER, FETCH_WECHAT_TRAINER } from '@/store/wechat/types';
import { FETCH_TRAINER } from '@/store/trainer/types';
import { FETCH_COACH } from '@/store/coach/types';

import WeChat from '@/router/wechat';
import Share from '@/router/share';
import Coach from '@/router/coach';
import Trainer from '@/router/trainer';
import Course from '@/router/course';
import TrainerApply from '@/router/trainer_apply';
import Guide from '@/router/guide';
import { SCOPE_SNSAPI_USERINFO } from '@/constants/wechat';

Vue.use(Router);

const needWechatAuth = route => route.matched.some(record => record.meta.wechat_auth);
const needTrainerAuth = route => route.matched.some(record => record.meta.trainer_auth);

const getWechatScope = route => (route.meta.trainer_auth ? SCOPE_SNSAPI_USERINFO : route.meta.wechat_auth);

const needAuth = (route) => {
    // 把 auth meta 转化成 scope
    const scope = getWechatScope(route);
    if (!scope) {
        return false;
    }

    // 未登录使用当前scope登录
    if (!auth.loggedIn()) {
        wechat.authorize(route.fullPath, scope);
        return true;
    }

    // 从 base 到 userinfo
    if (scope === SCOPE_SNSAPI_USERINFO && wechat.scope() !== SCOPE_SNSAPI_USERINFO) {
        wechat.authorize(route.fullPath, SCOPE_SNSAPI_USERINFO);
        return true;
    }

    return false;
};

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/courses',
        },
        ...WeChat,
        ...Share,
        ...Coach,
        ...Trainer,
        ...Course,
        ...TrainerApply,
        ...Guide,
    ],
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || config.title;

    if (needAuth(to)) {
        next(false);
    } else {
        if (needWechatAuth(to)) {
            if (!store.state.wechat.wechat_user) {
                store.dispatch(`wechat/${FETCH_WECHAT_USER}`);
            }
            if (!store.state.wechat.trainer) {
                store.dispatch(`wechat/${FETCH_WECHAT_TRAINER}`);
            }
        }
        if (needTrainerAuth(to)) {
            if (!store.state.trainer.trainer) {
                store.dispatch(`trainer/${FETCH_TRAINER}`);
            }
            if (!store.state.coach.coach) {
                store.dispatch(`coach/${FETCH_COACH}`);
            }
        }
        next();
    }
});

router.afterEach((to) => {
    if (!to.meta.bridge) {
        const url = `${location.origin}${to.fullPath}`;
        Vue.wechat.config(url);
    }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js